import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import { App } from './app';
import './index.css';

class RootElementNotFoundError extends Error {
  constructor() {
    super('Root element not found');
    this.name = 'RootElementNotFoundError';
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new RootElementNotFoundError();
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
